module.exports = __webpack_public_path__ + "static/get-ready-4-bd7ddb0f6a98b8bc8fd2e7ab97653503.png";